const shared = {
  welcome: 'Welcome to Velocity',
  get_started_with_plugin: 'Install our plugin to get started',
  get_started_description:
    'Instant validation on your earliest designs,\nbefore human feedback.',
  no: 'No',
  yes: 'Yes',
  disable: 'Disable',
  enable: 'Enable',
  feature_preview: 'Feature preview',
  loading: 'Loading...',
  save: 'Save',
  save_and_close: 'Save & close',
  save_preferences: 'Save preferences',
  back: 'Back',
  cancel: 'Cancel',
  close: 'Close',
  create: 'Create',
  confirm: 'Confirm',
  try_again: 'Try again',
  remove: 'Remove',
  edit: 'Edit',
  add: 'Add',
  rename: 'Rename',
  invite: 'Invite',
  download: 'Download',
  download_from_marketplace: 'Download from marketplace',
  continue: 'Continue',
  delete: 'Delete',
  transfer: 'Transfer',
  go_back: 'Go back',
  go_to_main_page: 'Go to main page',
  go_to_homepage: 'Go to homepage',
  home: 'Home',
  download_plugin: 'Download Figma Plugin',
  figma_plugin_description:
    'Until published on Community Marketplace, our Figma plugin is available for download here.',
  figma_plugin_marketplace_description:
    'Download latest version of our Figma plugin from the marketplace.',
  back_to_projects: 'Back to workspaces',
  placeholder_text: 'The quick brown fox jumps over the lazy dog',
  offline: 'Offline. Trying to reconnect...',
  errors: {
    something_went_wrong: 'Something went wrong',
    page_not_found: "It looks like we can't find the page you're looking for.",
    maximum_upload_size_exceeded: 'Maximum upload size exceeded',
    maximum_image_size_exceeded: 'Maximum image size exceeded',
    validation_error: 'Error occurred during validation',
  },
  privacy_policy: 'Privacy policy',
  software_license: 'Software license',
  security_policy: 'Security policy',
  eula_agreement: 'EULA - Terms of Service',
  about: 'About',
  where_to_start: {
    title: 'Create your first test',
    subtitle: 'Not sure where to start?',
    example: 'Try our example',
    watch_demo: 'Watch demo',
    description:
      'Review single pages or challenge whole interactive prototypes and get human-grade feedback in seconds',
  },
  need_a_hand: {
    title: 'Need a hand? Check out our resources',
  },
  badge: {
    successful: 'Successful',
    unsuccessful: 'Unsuccessful',
    in_progress: 'In progress',
    paused: 'Paused',
  },
  save_plugin: {
    title: 'Enjoy using the plugin? Save it!',
    close: 'Close',
    save: 'Go to plugin page',
    url: 'https://www.figma.com/community/plugin/1397952939678206595',
  },
  results_footer: {
    text: 'Our AI might make mistakes',
    tooltip:
      'This feedback was generated using AI, which means its accuracy can vary. It can provide useful insights, but it may also miss the mark or misinterpret context. ' +
      'It’s not designed to replace human testing so use your judgment, and keep humans in the loop.',
    url: 'https://www.figma.com/community/plugin/1397952939678206595',
  },
  home_slogan: 'Ready to put your design to work?',
  show_more: 'Show more',
  more_filters: 'More filters ({{count}})',
  reset: 'Reset',
  apply: 'Apply',
  from: 'From',
  to: 'To',
  coming_soon: 'Coming soon!',
  filter_by: 'Filter by:',
  date_filter: {
    title: 'Dates',
    all: 'All time',
    custom: 'Custom',
    last_24_hours: 'Last 24 hours',
    last_week: 'Last week',
    last_30_days: 'Last 30 days',
    last_6_months: 'Last 6 months',
    last_12_months: 'Last 12 months',
  },
} as const;

export default shared;
